import type { LoadingState } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import { prop } from '@ipfabric/utils/fp/prop';
import { DeviceView } from 'components/DeviceView/DeviceView';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import {
  initialTechnologies,
  isPathLookupGraphMetadata,
} from 'components/Graph/GraphState';
import { selectIntentRule } from 'components/Graph/model/selectors/overlay/selectIntentRule';
import { selectPathInspectorPackets } from 'components/Graph/model/selectors/selectPathInspectorPackets';
import { memo } from 'react';
import type { FC } from 'react';
import { isOneOf } from 'utils/isOneOf';
import { selectSnapshotToCompareId } from './model/selectors/overlay/selectSnapshotToCompareId';

interface Props {
  windowContainer: HTMLDivElement | null;
}

const BareGraphDeviceView: FC<Props> = (props) => {
  const ctxProps = useGraphContextSelectors({
    decisions: (s) =>
      isPathLookupGraphMetadata(s.graphMetadata)
        ? s.graphMetadata.decisions
        : null,
    deviceView: prop('deviceView'),
    graphLoading: (s) => isOneOf<LoadingState>(s.loading, 'INITIAL', 'LOADING'),
    intentRule: selectIntentRule,
    loadedGraphSnapshotId: (s) => s.graphMetadata?.snapshotId ?? null,
    pathInspectorPackets: selectPathInspectorPackets,
    pathLookupPathInspector: prop('pathlookup', 'pathInspector'),
    pathLookupPreset: prop('pathlookup', 'preset'),
    snapshotToCompareId: selectSnapshotToCompareId,
    stpInstances: (s) =>
      s.technologies.selectedTechnologies.stpInstances ??
      initialTechnologies.stpInstances,
  });

  return (
    <DeviceView
      decisions={ctxProps.decisions}
      deviceView={ctxProps.deviceView}
      hoveredPathInspectorEdge={ctxProps.pathLookupPathInspector.hoveredEdge}
      intentRule={ctxProps.intentRule}
      isolateStpInstances={ctxProps.stpInstances.isolate}
      stpInstances={ctxProps.stpInstances.instances}
      panelClassName='relative z-0'
      pathInspectorPackets={ctxProps.pathInspectorPackets}
      pathLookupPathInspectorSelectedPackets={
        ctxProps.pathLookupPathInspector.selectedPackets
      }
      pathLookupPreset={ctxProps.pathLookupPreset}
      showLoader={ctxProps.graphLoading}
      snapshotId={ctxProps.loadedGraphSnapshotId}
      snapshotToCompareId={ctxProps.snapshotToCompareId}
      windowContainer={props.windowContainer}
    />
  );
};

export const GraphDeviceView = memo(BareGraphDeviceView);
